import React, { useState, useEffect } from 'react';
import {
    SideNav, SideNavItems, SideNavMenu, SideNavMenuItem,
    HeaderContainer, Header, SkipToContent, HeaderMenuButton, Button
} from 'carbon-components-react';
import { TreeView24, DotMark16 as Bullet, DecisionTree24 } from '@carbon/icons-react';

const DashboardSideNavFilter = (props) => {
    const [expandSideNav, setExpandSideNav] = useState(false);
    const toggleSideNav = (bool) => {
        setExpandSideNav(!bool)
    }
    const hideSideNav = () => {
        setExpandSideNav(false)
    }
    return (
        <HeaderContainer
            render={({ isSideNavExpanded, onClickSideNavExpand }) => (
                <>
                    <Header aria-label="">
                        <SkipToContent />
                        <HeaderMenuButton
                            aria-label="Open menu"
                            isCollapsible
                            onClick={() => { onClickSideNavExpand(); toggleSideNav(isSideNavExpanded) }}
                            isActive={expandSideNav}
                        />
                        <SideNav
                            aria-label="Side navigation"
                            isRail
                            expanded={expandSideNav}>
                            <SideNavItems>
                                {props.navMenu && props.navMenu.length && props.navMenu.map((level1) => (
                                    <SideNavMenu renderIcon={props.selectedMenu === level1.key ? TreeView24 : DecisionTree24} title={<span title={level1.key}>{level1.key}</span>}>
                                        {level1["3"] && level1["3"].buckets && level1["3"].buckets.length && level1["3"].buckets.map((level2) => (
                                            level2["4"].buckets.length ?
                                                <SideNavMenu aria-current={props.selectedMenu === level1.key} className="shift-left-2" renderIcon={Bullet} title={<span title={level2.key}>{level2.key}</span>}>
                                                    {level2["4"] && level2["4"].buckets && level2["4"].buckets.length && level2["4"].buckets.map((level3) => (
                                                        level3["5"].buckets.length ?
                                                            <SideNavMenu className="shift-left-3" renderIcon={Bullet} title={<span title={level3.key}>{level3.key}</span>}>
                                                                {level3["5"] && level3["5"].buckets && level3["5"].buckets.length && level3["5"].buckets.map((level4) => (
                                                                    level4["6"].buckets.length ?
                                                                        <SideNavMenu className="shift-left-4" renderIcon={Bullet} title={<span title={level4.key}>{level4.key}</span>}>
                                                                            {level4["6"] && level4["6"].buckets && level4["6"].buckets.length && level4["6"].buckets.map((level5) => (
                                                                                <SideNavMenuItem className="shift-left-5" renderIcon={Bullet} onClick={() => { props.reloadData([level1.key, level2.key, level3.key, level4.key, level5.key]); hideSideNav() }}>
                                                                                    <Button kind='ghost' size='sm'><span title={level5.key}>{level5.key}</span></Button>
                                                                                </SideNavMenuItem>
                                                                            ))}
                                                                        </SideNavMenu>
                                                                        :
                                                                        <SideNavMenuItem className="shift-left-5" renderIcon={Bullet} onClick={() => { props.reloadData([level1.key, level2.key, level3.key, level4.key]); hideSideNav() }}>
                                                                            <Button kind='ghost' size='sm'><span title={level4.key}>{level4.key}</span></Button>
                                                                        </SideNavMenuItem>
                                                                ))}
                                                            </SideNavMenu>
                                                            :
                                                            <SideNavMenuItem onClick={() => { props.reloadData([level1.key, level2.key, level3.key]); hideSideNav() }}>
                                                                <Button kind='ghost' size='sm'>{level3.key}</Button>
                                                            </SideNavMenuItem>
                                                    ))}
                                                </SideNavMenu>
                                                :
                                                <SideNavMenuItem onClick={() => props.reloadData([level1.key, level2.key])}>
                                                    <Button kind='ghost' size='sm'>{level2.key}</Button>
                                                </SideNavMenuItem>
                                        ))}
                                    </SideNavMenu>
                                ))}
                            </SideNavItems>
                        </SideNav>
                    </Header>
                </>
            )}
        />
    );
}

export default DashboardSideNavFilter
